import { memo, type MouseEvent } from "react";

import {
  type CartLine,
  type SelectedOption,
} from "@shopify/hydrogen-react/storefront-api-types";

import { CartProductGiftItem } from "@cart/CartProductGiftItem";
import { CartProductGiftUnassignedItems } from "@cart/CartProductGiftUnassignedItems";

type Props = {
  cartLineUpdating: boolean;
  handleOpenGiftWithPurchaseDrawer: (e: MouseEvent<HTMLElement>) => void;
  handlePreloadProduct: (e: MouseEvent<HTMLElement>) => void;
  selectedGiftsWithPurchase: CartLine[] | undefined;
  selectedOptions: Partial<SelectedOption>[] | undefined;
  shippingNote: string | null;
};

const CartProductGiftItemSelectionViewBase = ({
  cartLineUpdating,
  handleOpenGiftWithPurchaseDrawer,
  handlePreloadProduct,
  selectedGiftsWithPurchase,
  selectedOptions,
  shippingNote,
}: Props) => {
  return (
    <>
      {selectedGiftsWithPurchase?.map((giftLine, index) => (
        <CartProductGiftItem
          cartLineUpdating={cartLineUpdating}
          giftLine={giftLine}
          key={`${giftLine.id}-${index}`}
          selectedOptions={selectedOptions}
          shippingNote={shippingNote}
        />
      ))}
      <CartProductGiftUnassignedItems
        handleOpenGiftWithPurchaseDrawer={handleOpenGiftWithPurchaseDrawer}
        handlePreloadProduct={handlePreloadProduct}
      />
    </>
  );
};

export const CartProductGiftItemSelectionView = memo(
  CartProductGiftItemSelectionViewBase
);
